import { callApi_v2 } from 'src/utils/api_v2';

interface VersionsResponse {
  scope: string;
  version: string;
}

export const fetchVersions = async (): Promise<VersionsResponse> => {
  const response = await callApi_v2({
    api: 'ENGINE_AFFINITY',
    method: 'GET',
    endpoint: '/insights/version',
  });

  return response.data;
};
